import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { DocumentsSettingsState, DOC_SETTINGS_SLICE_NAME } from './models';

export const documentsSettingsSelector = (state: RootState): DocumentsSettingsState => state[DOC_SETTINGS_SLICE_NAME];

export const selectDocumentsIsLoading = createSelector(
  documentsSettingsSelector,
  (state: DocumentsSettingsState) => state.isLoading,
);

export const selectRequiredDocuments = createSelector(documentsSettingsSelector, (state: DocumentsSettingsState) => {
  const requiredDocuments = Object.entries(state.documents ?? {});
  return {
    requiredDocuments,
    totalRequiredDocuments: requiredDocuments?.reduce(
      (acc, [_, value]) => value.filter((item) => item.is_required).length + acc,
      0,
    ),
  };
});
